// extracted by mini-css-extract-plugin
module.exports = {"MenuItem":"MenuItem_MenuItem__IF0q0","theme-light":"MenuItem_theme-light__zlewZ","theme-dark":"MenuItem_theme-dark__1CvhB"};